import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import { PrimaryButton as PrimaryButtonBase } from "components/misc/Buttons.js";

import LogoImage from "images/logo.png";
import { ReactComponent as FacebookIcon } from "images/facebook-icon.svg";
import { ReactComponent as TwitterIcon } from "images/twitter-icon.svg";
import { ReactComponent as YoutubeIcon } from "images/youtube-icon.svg";
import { ReactComponent as InstagramIcon } from "images/instagram-icon.svg";
import { ReactComponent as WhatsappIcon } from "images/whatsapp-icon.svg";

const Container = tw.div`relative bg-gray-200 text-gray-700 -mb-8 -mx-8 px-8 py-20 lg:py-24`;
const Content = tw.div`max-w-screen-xl mx-auto relative z-10`;
const SixColumns = tw.div`
  flex flex-wrap text-center sm:text-left justify-start gap-x-12 -mt-12
`;

const Column = tw.div`px-4 sm:px-0 sm:w-1/4 md:w-auto mt-12`;

const ColumnHeading = tw.h5`uppercase font-bold`;

const LinkList = tw.ul`mt-6 text-sm font-medium`;
const LinkListItem = tw.li`mt-3`;
const Link = tw.a`border-b-2 border-transparent hocus:border-gray-700 pb-1 transition duration-300`;

const SubscribeNewsletterColumn = tw(Column)`text-center lg:text-left w-full! lg:w-auto! mt-20 lg:mt-12`;
const SubscribeNewsletterContainer = tw.div`max-w-sm mx-auto lg:mx-0 `;
const SubscribeText = tw.p`mt-2 lg:mt-6 text-sm font-medium text-gray-600`;
const SubscribeForm = tw.form`mt-4 lg:mt-6 text-sm sm:flex max-w-xs sm:max-w-none mx-auto sm:mx-0`;
const Input = tw.input`bg-gray-300 px-6 py-3 rounded sm:rounded-r-none border-2 sm:border-r-0 border-gray-400 hover:border-pbsGreen-500 focus:outline-none transition duration-300 w-full`;
const SubscribeButton = tw(PrimaryButtonBase)`mt-4 sm:mt-0 w-full sm:w-auto rounded sm:rounded-l-none px-8 py-3`;

const Divider = tw.div`my-16 border-b-2 border-gray-300 w-full`;

const ThreeColRow = tw.div`flex flex-col md:flex-row items-center justify-between`;

const LogoContainer = tw.div`flex items-center justify-center md:justify-start`;
const LogoImg = tw.img`w-8`;
const LogoText = tw.h5`ml-2 text-xl font-black tracking-wider text-gray-800`;

const CopywrightNotice = tw.p`text-center text-sm sm:text-base mt-8 md:mt-0 font-medium text-gray-500`;

const SocialLinksContainer = tw.div`mt-8 md:mt-0 flex`;
const SocialLink = styled.a`
  ${tw`cursor-pointer p-2 rounded-full bg-gray-900 text-gray-100 hover:bg-gray-700 transition duration-300 mr-4 last:mr-0`}
  svg {
    ${tw`w-4 h-4`}
  }
`;

export default () => {
  return (
    <Container>
      <Content>
        <SixColumns>
          <Column>
            <ColumnHeading>Links</ColumnHeading>
            <LinkList>
              <LinkListItem>
                <Link href="/info-corner">Info Corner</Link>
              </LinkListItem>
              {/* <LinkListItem>
                <Link href="#">FAQs</Link>
              </LinkListItem> */}
              <LinkListItem>
                <Link href="/jobs">Career</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="/about">About Us</Link>
              </LinkListItem>
            </LinkList>
          </Column>
          <Column css={tw`border-l border-black pl-6`}>
            <ColumnHeading>Contact & Address</ColumnHeading>
            <LinkList>
              <LinkListItem>
                <Link >Shop 14 MidSpring Plaza</Link>
              </LinkListItem>
              <LinkListItem>
                <Link >134 Constant Spring Road, Kingston 8</Link>
              </LinkListItem>
              <LinkListItem>
                <Link >placementservicebiz@gmail.com</Link>
              </LinkListItem>
              <LinkListItem>
                <Link >Landline: +1 (876) 926-8359</Link>
              </LinkListItem>
              <LinkListItem>
                <Link>
                  <span>Cell/Whatsapp: </span>
                  <span style={{ whiteSpace: 'nowrap' }}>+1 (876) 874-7052 | +1 (876) 455-3105</span>
                </Link>
              </LinkListItem>
            </LinkList>
          </Column>
        </SixColumns>
        <Divider />
        <ThreeColRow>
          <LogoContainer>
            <LogoImg src={LogoImage} />
            <LogoText>Placement & Business Services Ltd.</LogoText>
          </LogoContainer>
          <CopywrightNotice>&copy; {new Date().getFullYear()} Placement & Business Services Ltd. All Rights Reserved.</CopywrightNotice>
          <SocialLinksContainer>
            {/* <SocialLink href="https://www.facebook.com/pbsja/">
              <FacebookIcon />
            </SocialLink> */}
            <SocialLink href="https://www.instagram.com/placement_business_services/" target="_blank" rel="noopener noreferrer">
              <InstagramIcon />
            </SocialLink>
            <SocialLink href="https://wa.me/18764553105" target="_blank" rel="noopener noreferrer">
              <WhatsappIcon />
            </SocialLink>
            {/* <SocialLink href="https://youtube.com">
              <YoutubeIcon />
            </SocialLink> */}
          </SocialLinksContainer>
        </ThreeColRow>
      </Content>
    </Container>
  );
};
